import cn from 'classnames';

// LDS Internal component. Not exported for general use

export default function MobileExpandPanel({
  expanded = false,
  children,
  className,
  ...rest
}) {
  return (
    <div
      className={cn(
        'mobile-expand-panel',
        className,
        { expanded }
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
